module.exports = __webpack_public_path__ + "static/media/videocall.f394da7b.png";